import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { PENDING, IDLE } from "const"
import { MtProjectGroup, MtProjectGroupCreate } from "server/models"
import {
    useInput,
    StateType,
} from "client/utils"
import {
    StoreType,
    SaveProjectGroup,
    closeModal,
    setProjectGroupEdit,
    setProjectGroupReloadList,
    setProjectGroupReloadEdit,
    ProjectGroupValidation,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Input,
    Feedback,
    Button,
    SpinnerIcon,
    Textarea,
    SelectDropdown,
    SelectDropdownItem,
} from "client/components"

interface EditProjectGroupProps {
    group: MtProjectGroup
    readOnly: boolean
}

let isMounted: boolean

const Form = ({
    group,
    readOnly,
}: EditProjectGroupProps) => {
    const modals = useSelector((state: StoreType) => state.system.modals)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [name, setName] = useInput(group.name)
    const [description, setDescription] = useInput(group.description)

    const [isDefault, setIsDefault] = useState(group.default)
    const [validation, setValidation] = useState<ProjectGroupValidation>(null)

    const [saveState, setSaveState] = useState<StateType>(IDLE)
    const [applyState, setApplyState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    const onClose = () => {
        if (!isMounted) return
        if (modals.length) dispatch(closeModal())
    }

    const onSave = (mode: number) => {
        if (mode === 1) setSaveState(PENDING)
        if (mode === 2) setApplyState(PENDING)

        const newGroupData: MtProjectGroupCreate = {
            groupId: group.groupId || null,
            accountId: group.accountId || userData.accountId,
            projectId: null,
            name,
            description,
            creator: group.groupId ? group.creator : userData.userId,
            default: isDefault,
            order: group.order,
        }

        SaveProjectGroup(newGroupData, lang)
        .then((res) => {
            if (isMounted) {
                setValidation(res.validation)
                setSaveState(IDLE)
                setApplyState(IDLE)
            }
            if (res.validation) return

            dispatch(setProjectGroupEdit({
                ...newGroupData,
                groupId: res.newGroupId || group.groupId,
                order: res.newGroupOrder || group.order,
            }))

            dispatch(setProjectGroupReloadList(false))
            setTimeout(() => {
                dispatch(setProjectGroupReloadList(true))
            }, 0)

            if (mode === 1) onClose()
            if (mode === 2) {
                dispatch(setProjectGroupReloadEdit(false))
                setTimeout(() => {
                    dispatch(setProjectGroupReloadEdit(true))
                }, 0)
            }
        })
    }

    return (
        <PageForm>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>{lang.name}</Label>
                        <Input type="text" value={name} onChange={setName} readOnly={readOnly} />
                        <Feedback>{validation && validation.name}</Feedback>
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.description}</Label>
                        <Textarea value={description} onChange={setDescription} readOnly={readOnly} />
                        <Feedback>{validation && validation.description}</Feedback>
                    </FormGroup>
                    {
                        userData.accountId === 1
                        && (
                            <FormGroup>
                                <Label>{lang.default}</Label>
                                <SelectDropdown title={isDefault ? lang.yes : lang.no}>
                                    <SelectDropdownItem onClick={() => setIsDefault(true)}>{lang.yes}</SelectDropdownItem>
                                    <SelectDropdownItem onClick={() => setIsDefault(false)}>{lang.no}</SelectDropdownItem>
                                </SelectDropdown>
                                <Feedback>{validation && validation.default}</Feedback>
                            </FormGroup>
                        )
                    }
                </Col>
                {
                    !readOnly && (
                        <Col xs={12}>
                            <Button variant="success" row onClick={() => onSave(1)}>
                                {saveState === PENDING ? <SpinnerIcon /> : lang.save}
                            </Button>
                            <Button variant="success" row onClick={() => onSave(2)}>
                                {applyState === PENDING ? <SpinnerIcon /> : lang.apply}
                            </Button>
                            <Button row onClick={onClose}>{lang.cancel}</Button>
                        </Col>
                    )
                }
            </Row>
        </PageForm>
    )
}
export default Form
